import angular from 'angular';
import template from './template.html';
import './style.scss';
import _ from 'lodash';

export class editEmployerRepModalCtrl {
    /* @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }

    async $onInit() {
        this.isLoading = true;
        this.isLinkedinEditing = false;
        const { name, email, phones, title, linkedin } = this.resolve.employerRep;
        this.updatedEmployerRep = {
            name,
            email,
            linkedin,
            phone: _.get(phones, '0.value'),
            title,
        };
        this.linkedinUrlWidth = '0px';
        this.setLinkedinUrlWidth();
    }

    setLinkedinEditing(isEditing) {
        this.isLinkedinEditing = isEditing;
    }

    setLinkedinUrlWidth() {
        const chars = _.get(this.updatedEmployerRep, 'linkedin.length', 0);
        if (chars > 0) {
            this.linkedinUrlWidth = `${chars * 6.5}px`;
            return;
        }
        this.linkedinUrlWidth = '0px';
    }

    openLinkedinProfile () {
        const linkHasProtocol = /^(http(s)?:\/\/)/;
        const linkedinProfile = this.updatedEmployerRep.linkedin;
        const url = !linkedinProfile.match(linkHasProtocol) ? `https://${linkedinProfile}` : linkedinProfile;
        window.open(url, '_blank');
    }

    save() {
        const employerRepToSave = {
            ...this.resolve.employerRep,
            name: this.updatedEmployerRep.name,
            phones: this.updatedEmployerRep.phone ? [{
                type: 'Work',
                value: this.updatedEmployerRep.phone,
            }] : [],
            linkedin: this.updatedEmployerRep.linkedin,
            title: this.updatedEmployerRep.title,
        };
        this.modalInstance.close(employerRepToSave);
    }

    close() {
        this.modalInstance.dismiss();
    }
}

export const editEmployerRepModalCtrlConfiguration = {
    controller: editEmployerRepModalCtrl,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
    template,
};

angular
    .module('TALENYA-FE')
    .component('editEmployerRepModalCtrl', editEmployerRepModalCtrlConfiguration);
